import { Helper } from 'Explore/LastUpload/LastUpload.styles';

const { default: styled } = require('styled-components');

// Styled components
export const Container = styled.div`
	display: flex;
	width: 80%;
	justify-content: start;
	margin: 10px;
	padding-left: 5px;
`;

export const StyledHelper = styled(Helper)`
	margin-top: 32px;
	margin-left: 5px;
	line-height: 0;
`;
